import React, {Component} from 'react';
import {Accordion, Icon} from 'semantic-ui-react';
import headerBorder from '../../assets/images/line-orange.png';

export default class DataPrivacy extends Component{
	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	state = { activeIndex: 0 }

	handleClick = (e, titleProps) => {
		const { index } = titleProps
		const { activeIndex } = this.state
		const newIndex = activeIndex === index ? -1 : index

		this.setState({ activeIndex: newIndex })
	}
	
	render(){
		const { activeIndex } = this.state
		
		return (
			<>
				
				<div className="section-content-wrapper data-privacy-wrapper">
					<div className="align-center">
						<h1 className="section-header">About our privacy policy</h1>
						<img src={headerBorder} className="header-border" alt="" />
						<p className="para-content">We want you to understand our Privacy Policy and what it means to you.
						</p>
					</div>
					<Accordion styled>
						<Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
							<Icon name='dropdown' /> About your personal information
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 0}>
							<p className="para-content">Personal information is information about an identifiable individual and includes your name,
								contact information, travel itinerary and other information described below.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your consent
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 1}>
							<p className="para-content">By using our websites, providing any personal data to us, or booking any travel services
								with us, that you confirm that you agree to and consent to the terms of this policy, to
								the extent that your consent is required by any applicable law.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your concerns
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 2}>
							<p className="para-content">By using our websites, providing any personal data to us, or booking any travel services with us, that you confirm
								that you agree to and consent to the terms of this policy, to the extent that your consent is required by any
								applicable law.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 3} index={3} onClick={this.handleClick}>
							<Icon name='dropdown' /> Terms used in this policy
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 3}>
							<p className="para-content">When we refer to “you” and “your” in this privacy policy, we refer to you, any such individual whose personal
								data we process from time to time.
							</p>
							<p className="para-content"> When we refer to “processing” of your personal data, this includes obtaining, recording, storing or
								holding your personal data, and anything we do with it, such as organizing, adapting or altering it, retrieving,
								consulting or using it, disclosing it or otherwise making it available to others, combining it with other data, and
								blocking, erasing or destroying it.
							</p>
							<p className="para-content">When we refer to "travel services" this covers all products and services which may be booked with or
								through us, such as customized holidays, package holidays, accommodation, tours, transport and transfers (whether by
								air, coach, bus, train, ferry, taxi or other means), car hire, cruises, and charters, and it includes both (1) all
								such products and services which we supply or operate ourselves (including where we sub-contract); and (2) any such
								products and services provide by a third party which we book for you (acting as agent for you or that third
								party). Travel services also includes any services we or a third party provide in association with travel, such as
								obtaining visas, foreign exchange, and providing local representatives and support.
							</p>

						</Accordion.Content>

						<Accordion.Title active={activeIndex === 4} index={4} onClick={this.handleClick}>
							<Icon name='dropdown' /> Booking travel services
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 4}>
							<p className="para-content">Light Miles Travel may collect, use or disclose your personal information, either directly or through our
								partners, for the purposes of offering or booking travel services on your behalf, such as your name, age, address, phone number,
								email address, emergency contact information, passport information, travel medical information (where required), insurance details,
								nationality, residency, nutrition preferences, trip evaluations, travel and accommodation preferences, comments you provide us, trip
								destination information, and payment-related information. This personal information enables us to provide you with trip information,
								book flights, accommodations, process payments, and provide similar travel services.
							</p>
							<p className="para-content">
								Please be aware that Light Miles Travel may be required to provide certain personal information to our local service providers
								(third party operators) for the purposes of delivering your experience. When you book travel services with us, you consent to
								the collection, use and disclosure of your personal information by Light Miles Travel—and the corresponding collection and use by
								the relevant travel partners or suppliers—for the purposes of administering and delivering the travel services you requested.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 5} index={5} onClick={this.handleClick}>
							<Icon name='dropdown' /> What types of personal data we process
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 5}>
							<p className="para-content">This includes name, age, photograph, gender, address, telephone, mobile, fax, e-mail, social networking
								contact details, proofs of identity and address, copies of passports, driving licenses, and utility bills, card and other payment
								details, and financial information, health information relevant to your planned travel, and travel insurances held, results of searches
								carried out against you (such as to verify you identity, address, and credit status), your preferences, frequent flyer or travel
								partner program affiliation and member number, and any other information provided to us by or in relation to you which concern you 
								as an individual.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 6} index={6} onClick={this.handleClick}>
							<Icon name='dropdown' />Business related information
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 6}>
							<p className="para-content">If you are an individual associated with a business or other organization that is our customer, then your 
							personal data may include the following information that we link to you: business or organization details (such as name, address, 
							telephone numbers, payment arrangements, financial information, etc.), your relationship with that business or organization 
							(such as owner, partner, director, shareholder, employee, or agent), and your contact details within that business 
							(such as work address, work telephone and mobile numbers, work fax number, and work e-mail address).

							</p>
						</Accordion.Content>


						<Accordion.Title active={activeIndex === 7} index={7} onClick={this.handleClick}>
							<Icon name='dropdown' />Enquiry and Booking information
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 7}>
							<p className="para-content">Information concerning enquiries and bookings made with or through us for travel services, including
							where you are making the enquiry or booking or are the recipient of the travel services to which the enquiry or booking relates.
							This information may include: records of enquiries and searches for holiday and travel products made by or on your behalf, details
							of your personal interests, needs and other data relevant to your enquiry; details of results, quotes, proposals, estimates and other
							information given in response to enquiries; details of the holiday, accommodation, travel, car hire, and other travel services booked 
							or enquired about; details of the passengers travelling; details of the provider of the travel services (e.g. tour operator); dates 
							and times of travel; price; payment details (including card details); passport information and visa information; foreign exchange 
							requirements and arrangements; and sensitive information such as health, medical, dietary, mobility, disability, religious or other 
							special conditions or requirements.

							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 8} index={8} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your personal information may also be used for the purposes of:
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 8}>
							<ul className="para-content privacy-list">
								<li>Enabling Light Miles Travel to better understand your needs and wants in relation to your travel experience;</li>
								<li>Informing you about our products and services, or those of our partners that we believe may be of interest to you (provided that
									we have received valid consent from you if such consent is required);
								</li>
								<li>Providing customer service and support during tour implementation;</li>
								<li>Ensuring the safety and security of our passengers and products;</li>
								<li>Carrying out internal accounting and administration of our business;</li>
								<li>Complying with laws, regulations, and immigration requirements;</li>
								<li>Surveys, online promotions, newsletters.</li>
							</ul>
							<p className="para-content">
								If we do not collect your personal information, we may be unable to provide our services to you.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 9} index={9} onClick={this.handleClick}>
							<Icon name='dropdown' /> Service Provider Arrangements
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 9}>
							<p className="para-content">In addition to the third-party travel suppliers outlined above, Light Miles Travel may transfer your 
							personal information to third parties who provide services on our behalf. For example, we may use service providers to authorise 
							and process payments, host our customer service operations, serve advertisements on our website, send email or other communications, 
							or run our contests and promotions. Your personal information may be maintained and processed by our service providers in the UK, US 
							or other jurisdictions. For information about the policies or practices of our service providers, please contact us at the email address 
							above. Our service providers are given the information they need to perform their designated functions, and we do not authorize them to 
							use or disclose your personal information for their own purposes.

							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 10} index={10} onClick={this.handleClick}>
							<Icon name='dropdown' /> Protection of your personal information
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 10}>
							<p className="para-content">We have implemented measures designed to help protect personal information in our custody and control.
							We main- tain reasonable administrative, technical and physical safeguards in an effort to protect against unauthorized access, 
							use, modification and disclosure of personal information in our custody and control. Unfortunately, no collection or transmission of 
							information over the Internet or other publicly accessible communications networks can be guaranteed to be 100% secure, and therefore, 
							we cannot ensure or warrant the security of any such information. We have personal information retention processes designed to retain 
							personal information of our customers for no longer than necessary for the purposes stated above or to otherwise meet legal 
							requirements.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 11} index={11} onClick={this.handleClick}>
							<Icon name='dropdown' /> Accessing your personal information
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 11}>
							<p className="para-content">You have the right to access, update, and correct inaccuracies in your personal information in our 
							custody and control, subject to certain exceptions prescribed by law. You may access, update, and/or correct much of your personal 
							information by requesting access, updates and corrections of inaccuracies in the personal information we have in our custody or control 
							by emailing or writing to us at the contact information provided. We may request certain personal information for the purposes of 
							verifying the identity of the individual seeking access to their personal information records.
							</p>

							<p className="para-content">
								If you have any questions about our Privacy Policy, you can contact our Privacy Officer at privacy@lightmilestravel.com.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 12} index={12} onClick={this.handleClick}>
							<Icon name='dropdown' /> Website Policies and Cookies
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 12}>
							<p className="para-content">Our website uses a technology called a “cookie,” which is a small element of data that our website can 
							send to your browser to be stored on your computer so that we can recognise your computer when you return. If you have registered 
							with our website, cookies may provide us and our service providers with information that we will use to personalize our website in 
							accordance with your preferences. Most web browsers allow you to modify your settings to notify you when you receive a cookie or to 
							reject cookies entirely. If you decide not to accept cookies from our website, you may not be able to take advantage of all of its 
							features.

							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 13} index={13} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your security measures
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 13}>
							<p className="para-content">For your own privacy protection, we encourage you to maintain anti-virus and other malware protection software 
							on your computers and other devices, and to maintain your own measures to protect your personal data. Please do not include sensitive 
							personal data in any e-mails you may send to us, including payment card information.
							</p>
							<p className="para-content">
								We also encourage you to be careful about who you give personal data to. We never contact you to ask you for sensitive personal data, 
								such as payment card information, or sensitive personal data such as passport numbers or log-in details, and we will only ask you for such 
								information in person or through our website, or by telephone in connection with a booking you are making or have made. Please let us know 
								if you someone purports to contact you in our name.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 14} index={14} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your Rights
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 14}>
							<p className="para-content">Our privacy policy is not intended to create a contract or form part of any contract. You have certain 
							non-contractual rights under the laws noted above, which we summarize below. If you contact us about these rights, we may ask for 
							proof of your identity before we act, and may refuse to act if you do not provide this or your identity is not established by you.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 15} index={15} onClick={this.handleClick}>
							<Icon name='dropdown' /> Changes to this Privacy Policy
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 15}>
							<p className="para-content">From time to time it may be necessary for Light Miles Travel to amend or make revisions to this Privacy 
							Policy. If we make a change to the Policy, the revised version will be posted on our website. Please refer to this Privacy Policy 
							for the latest information about our personal information practices.
							</p>
						</Accordion.Content>

						<Accordion.Title active={activeIndex === 16} index={16} onClick={this.handleClick}>
							<Icon name='dropdown' /> Applicable Law And Disputes
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 16}>
							<p className="para-content">This policy is subject to the Philippine Data Privacy Act 2012, and you must bring any claims against 
							us exclusively in the courts of the Philippines.
							</p>
						</Accordion.Content>


					</Accordion>
				</div>
			</>
		);
	}
}
